import { Const_OrderSet, pathwayType_SingleState } from './types.js';
export const PathwayTypeToLabel = {
    'chief-complaint': 'Chief Complaint',
    'treatment': 'Treatment',
    'differential-diagnosis': 'Differential Diagnosis',
    'triage': 'Nurse Triage',
    [pathwayType_SingleState]: 'Single State',
    [Const_OrderSet]: 'Order Set',
};
/**
 * Canonical Firebase Storage object path of a pathway's attached HTML. Single source of truth shared by
 * the importer (upload + rollback) and pathway delete (cleanup), so both derive it from pathwayId. This
 * is only the object name; the bucket is the environment's default bucket.
 */
export const pathwayHtmlStoragePath = (pathwayId) => `assets/pathways-html/${pathwayId}/pathway.html`;
//# sourceMappingURL=consts.js.map